import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useTranslations } from '../translations/translations';
import LanguageToggle from './LanguageToggle';
import { useLanguage, useLocalizedNavigate, stripLanguagePrefix } from '../contexts/LanguageContext';

const Header = ({ onScrollToContact }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useLocalizedNavigate();
  const location = useLocation();
  const { localizePath } = useLanguage();
  const t = useTranslations();

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleServicesClick = (e) => {
    e.preventDefault();
    // Si on est déjà sur la page d'accueil
    if (stripLanguagePrefix(location.pathname) === '/') {
      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Sinon, retourner à l'accueil puis scroller
      navigate('/');
      setTimeout(() => {
        document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
    setIsMenuOpen(false);
  };

  const handleConfidentialityClick = (e) => {
    e.preventDefault();
    navigate('/confidentialite');
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div 
          className="header-logo" 
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        >
          <img 
            src="/images/altes/logo-altes-hd-v2.png" 
            alt="ALTES PROTECTION" 
            className="logo-img"
            style={{ 
              height: '50px',
              width: 'auto',
              imageRendering: 'crisp-edges',
              filter: 'brightness(1.1) contrast(1.2)',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <a href="#services" onClick={handleServicesClick}>
            {t.header.services}
          </a>
          <a href="#moyens" onClick={(e) => { e.preventDefault(); document.getElementById('moyens')?.scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }}>
            {t.header.moyens}
          </a>
          <a href={localizePath('/confidentialite')} onClick={handleConfidentialityClick}>
            {t.header.confidentiality}
          </a>
          <a href="#contact" onClick={(e) => { e.preventDefault(); onScrollToContact?.(); setIsMenuOpen(false); }}>
            {t.header.contact}
          </a>
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
          <LanguageToggle />
          <button className="header-cta" onClick={onScrollToContact}>
            {t.header.cta}
          </button>
        </div>
        
        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
    </header>
  );
};

export default Header;
